import React from 'react';
import {SyncProblem} from "@airbus/icons/react"
import './ErrorHandler.scss';
import PropTypes from 'prop-types';

const ErrorHandler = (props) => {
  return (
    <div className="error-cls" data-testid="error-handler">
        <div className='header'>
          <span><SyncProblem style={{ verticalAlign: 'middle' }} />- Error</span>
        </div>
        <div className='content'>
          <span>{message(props.error)}</span>
        </div>
    </div>
  )
}
const message = (error) => {

  if (error && error.response && error.response.data.errorMessage ){
    return error && error.response && error.response.data.errorMessage.replace(/\[.*?\]/g, '').trim();
  }
  else
    { return String("Unable to load data, please contact support"); }
};


ErrorHandler.propTypes = {
  error: PropTypes.shape({
    response: PropTypes.shape({
      data: PropTypes.shape({
        errorMessage: PropTypes.string.isRequired
      })
    })
  })
};
export default ErrorHandler;